import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import Avatar from "../Avatar/Avatar";
import "./createaccount.scss";

const CreateAccount = ({ session }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [username, setUsername] = useState(null);

  const [avatar_url, setAvatarUrl] = useState(null);

  useEffect(() => {
    getProfile();
  }, [session]);

  const getProfile = async () => {
    try {
      setLoading(true);
      const user = supabase.auth.user();

      let { data, error, status } = await supabase
        .from("profiles")
        .select(`username, avatar_url`)
        .eq("id", user.id)
        .single();

      if (error && status !== 406) {
        throw error;
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const updateProfile = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const user = supabase.auth.user();

      const updates = {
        id: user.id,
        username,
        avatar_url,
        updated_at: new Date(),
      };

      let { error } = await supabase.from("profiles").insert(updates, {
        returning: "minimal",
      });

      navigate("/home");

      if (error) {
        throw error;
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="background"></div>
      <div className="full-view-container">
        <div className="account-container">
          <div aria-live="polite">
            <h2>Finish setting up your profile:</h2>
            {loading ? (
              "Saving ..."
            ) : (
              <form onSubmit={updateProfile} className="form-widget">
                <Avatar
                  className="image-container"
                  url={avatar_url}
                  size={200}
                  onUpload={(url) => {
                    setAvatarUrl(url);
                    updateProfile({ username, avatar_url: url });
                  }}
                />
                <div className="info-container">
                  <h3 className="email-container">
                    <div className="email-text">Email: </div>
                    {session.user.email}
                  </h3>
                  <h3 htmlFor="username" className="name-text">
                    Name:
                    <input
                      id="username"
                      type="text"
                      value={username || ""}
                      onChange={(e) => setUsername(e.target.value)}
                    />{" "}
                  </h3>
                </div>

                <div className="create-account">
                  <button className="edit-profile-button" disabled={loading}>
                    Create Account
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateAccount;
